export function getDefaults() {
  return {
    lang: 'en',
  };
}
